<template>
    <div class="domain">
        <h1>Domain</h1>
        <p>
            A domain is a collection of applications sharing the same business
            domain. This generally means the language used when talking about
            the applications.applications
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Domain",
});
</script>
